import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DatatableComponent } from '@basis/angular-components';
import { BaseComponent } from './base.component';
import { SelectItem } from 'primeng/primeng';
import { FiltroDeResultados } from 'app/entity/enumeraveis';
import { environment } from '../../environments/environment';

@Component({
    selector: 'base-list-filter-homologacao-profissional',
    template: `
    <form [formGroup]="filtro" novalidate>
        <div class="ui-g-14 ui-md-12 ui-lg-12">
          <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Código" formControlName="codigo"></form-text>
          <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Nome" formControlName="nome"></form-text>
          <form-text class="ui-g-12 ui-md-6 ui-lg-4" label="Nome Capacitadora" formControlName="nome_capacitadora"></form-text>
          <div class="ui-g-12  ui-md-12"></div>
        </div>
        <div class="ui-g-14 ui-md-12 ui-lg-12">
          <form-text class="ui-g-12 ui-md-6 ui-lg-3" label="Pesquisar por Profissional" formControlName="atividade"></form-text>
          <form-text class="ui-g-12 ui-md-6 ui-lg-3" label="Membro da comissão" formControlName="membro_comissao">
          </form-text>
          <form-select class="ui-g-12 ui-md-6 ui-lg-3" label="Situação" [options]="situacaoOptions | formatSelectItem: 'id':'nome'"
            formControlName="id_situacao"></form-select>
          <form-select class="ui-g-12 ui-md-6 ui-lg-3" formControlName="id_filtrar_resultado" [options]="filtroDeResultados | formatSelectItem: 'value':'label'"></form-select>
          <div class="ui-g-12  ui-md-12"></div>
        </div>
      </form>
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="ui-g-5 ui-md-2 ui-lg-2">
          <button pButton type="button" label="Limpar" (click)="limpar()" class="ui-button-white"></button>
        </div>
        <div class="ui-g-2 ui-md-8 ui-lg-8"></div>
        <div class="ui-g-5 ui-md-2 ui-lg-2">
          <button pButton type="button" label="Consultar" (click)="consultar($event)" class="ui-button-madison"></button>
        </div>
      </div>
    `})
    
export class BaseListFilterHomologacaoProfisssionalComponent  extends BaseComponent {
    @Input() filtro: FormGroup;
    @Input() listagem: DatatableComponent;
    @Input() filtroDeResultados: SelectItem[] = [];
    situacaoOptions: any;
    currentUrl: string = this.router.url;
    baseUrl = `${environment.apiEndpoint}`;

    init() {
    this.listagem.selectedRow = [];
      this.loadListAsEnum(this.filtroDeResultados, FiltroDeResultados);
      this.service.ListarTodos('combo/situacao').subscribe(
          data => {
              this.situacaoOptions = data;
          }
        );
    }

    consultar(event: any) {
      const params = new URLSearchParams();
      const formValue = this.filtro.value;
      this.listagem.pDatatableComponent.first = 0;
      this.listagem.selectedRow = [];

      for (const key in formValue) {
        if (formValue[key]) {
          params.append(key, formValue[key]);
        }
      }
      sessionStorage.setItem('funcionalidade', this.router.url.split('/')[2]);
      sessionStorage.setItem('filtro',params.toString());
      this.listagem.url = this.url(params);
      this.listagem.refresh();
    }

    url(filter: any = null): string {
      try {
        const query = sessionStorage.getItem('filtro');
        const lotacao = localStorage.getItem('lotacao') || '';
        const params = new URLSearchParams();

        const filtroAtualizado = { ...filter, id_lotacao: lotacao };
        this.addParams(params, filtroAtualizado);

        if (query) {
          const parametrosQuery = this.obterParametros(query);
          parametrosQuery.id_lotacao = lotacao;
          this.addParams(params, parametrosQuery);
        }

        const resource = this.currentUrl.split('/').pop() || '';
        return `${this.baseUrl}/${resource}/ObterTodosProcessado?${params.toString()}`;
      } catch (error) {
        console.error('Error generating URL:', error);
        return '';
      }
    }
    
    private addParams(params: URLSearchParams, filter: any): void {
      Object.keys(filter).forEach(key => params.set(key, filter[key]));
    }
    
    obterParametros(query: string): any {
      try {
        const parametros = query.split('&')
          .map(str => {
            const [key, value] = str.split('=');
            return { [key]: decodeURIComponent(value) };
          })
          .reduce((prev, curr) => ({ ...prev, ...curr }), {});

        return this.processarParametros(parametros);

      } catch (error) {
        console.error('Error processing query parameters:', error);
        return {};
      }
    }
    
    private processarParametros(parametros: any): any {
      Object.keys(parametros).forEach(key => {
        let valor = parametros[key];

        if (valor.indexOf('%2C') !== -1) {
          parametros[key] = valor.split('%2C');
          return;
        }

        valor = valor.replace('%2F', '/').split('+').join(' ');
        parametros[key] = valor === 'null' ? null : valor;

        if (key === 'exercicios' || key === 'situacoes') {
          parametros[key] = Array.isArray(parametros[key]) ? parametros[key].map(Number) : [Number(parametros[key])];
        }
      });
      return parametros;
    }

    limpar() {
        this.filtro.reset();
    }
}


// WEBPACK FOOTER //
// ./src/app/base/base-list-filter-homologacao-profissional.component.ts